// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  z-index: 10000;
}

.custom-tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  left: 50%;
  z-index: 10001;
  width: max-content;
  max-width: 260px;
  padding: 7px 9px;
  border-radius: 6px;
  background: #1f3448;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  text-align: left;
  white-space: normal;
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 4px);
  transition: opacity 140ms ease, transform 140ms ease;
}

.custom-tooltip-top::after {
  bottom: calc(100% + 8px);
}

.custom-tooltip-bottom::after {
  top: calc(100% + 8px);
  transform: translate(-50%, -4px);
}

.custom-tooltip-left::after {
  top: 50%;
  right: calc(100% + 8px);
  bottom: auto;
  left: auto;
  transform: translateY(-50%);
}

.custom-tooltip:hover::after,
.custom-tooltip:focus-within::after {
  opacity: 1;
  transform: translate(-50%, 0);
}

.custom-tooltip-left:hover::after,
.custom-tooltip-left:focus-within::after {
  transform: translateY(-50%);
}

.custom-tooltip.custom-tooltip-hidden::after {
  opacity: 0 !important;
  transform: translate(-50%, 4px);
}

.custom-tooltip.custom-tooltip-hidden.custom-tooltip-left::after {
  transform: translateY(-50%);
}
`, "",{"version":3,"sources":["webpack://./src/components/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,+BAA+B;EAC/B,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".custom-tooltip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  z-index: 10000;\n}\n\n.custom-tooltip::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  left: 50%;\n  z-index: 10001;\n  width: max-content;\n  max-width: 260px;\n  padding: 7px 9px;\n  border-radius: 6px;\n  background: #1f3448;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.35;\n  text-align: left;\n  white-space: normal;\n  opacity: 0;\n  pointer-events: none;\n  transform: translate(-50%, 4px);\n  transition: opacity 140ms ease, transform 140ms ease;\n}\n\n.custom-tooltip-top::after {\n  bottom: calc(100% + 8px);\n}\n\n.custom-tooltip-bottom::after {\n  top: calc(100% + 8px);\n  transform: translate(-50%, -4px);\n}\n\n.custom-tooltip-left::after {\n  top: 50%;\n  right: calc(100% + 8px);\n  bottom: auto;\n  left: auto;\n  transform: translateY(-50%);\n}\n\n.custom-tooltip:hover::after,\n.custom-tooltip:focus-within::after {\n  opacity: 1;\n  transform: translate(-50%, 0);\n}\n\n.custom-tooltip-left:hover::after,\n.custom-tooltip-left:focus-within::after {\n  transform: translateY(-50%);\n}\n\n.custom-tooltip.custom-tooltip-hidden::after {\n  opacity: 0 !important;\n  transform: translate(-50%, 4px);\n}\n\n.custom-tooltip.custom-tooltip-hidden.custom-tooltip-left::after {\n  transform: translateY(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
